import BlogList from "../components/BlogList";

const ListBlogPage = () => {
  return (
    <BlogList />
  );
};

export default ListBlogPage;
